import { requestSubscription, graphql } from "react-relay";
import { ConnectionHandler } from "relay-runtime";
import environment from "../Network";

const subscription = graphql`
  subscription NotificationSubscription {
    notificationSubscription {
      notification {
        id
        pk
        user {
          pk
          id
          firstName
          lastName
        }
        seen
        hidden
        management
        absenceStatus
        createdAt
        absence {
          status
          absenceType
          absenceTypeDisplay
          dateFrom
          dateTo
        }
        regardingUser {
          firstName
          lastName
        }
        employeeActivity {
          activity
        }
        lateness {
          declaredTime
          pk
          createdAt
        }
        meeting {
          pk
        }
        report {
          reportType {
            labelDisplay
          }
          project {
            name
          }
          pk
          taskIdManager
          numberOfMinutesManager
          noteManager
        }
      }
    }
  }
`;

export default (variables) => {
  return requestSubscription(
    environment, // see Environment docs
    {
      subscription,
      variables: variables ? variables : {},
      updater: (store) => {
        // Get the notification
        const rootField = store.getRootField("notificationSubscription");
        const notification = rootField.getLinkedRecord("notification");
        const userId = notification.getLinkedRecord("user").getValue("id");
        // Add it to a connection
        let viewer = store.getRoot().getLinkedRecord("user");
        if (viewer.getValue("id") === userId) {
          const adminDashboard = store
            .getRoot()
            .getLinkedRecord("adminDashboard");
          if (notification.getValue("management") && adminDashboard) {
            //management notifications
            let notifications = ConnectionHandler.getConnection(
              adminDashboard,
              "ManagementAbsencesTabs_notifications"
            );
            let notificationEdge = ConnectionHandler.createEdge(
              store,
              notifications,
              notification,
              "NotificationType"
            );
            ConnectionHandler.insertEdgeAfter(notifications, notificationEdge);

            notifications = ConnectionHandler.getConnection(
              adminDashboard,
              "NotificationManager_allNotifications"
            );
            notificationEdge = ConnectionHandler.createEdge(
              store,
              notifications,
              notification,
              "NotificationType"
            );
            ConnectionHandler.insertEdgeBefore(notifications, notificationEdge);
          }
          const notifications = ConnectionHandler.getConnection(
            viewer,
            "AbsencesTabs_notifications"
          );
          const notificationEdge = ConnectionHandler.createEdge(
            store,
            notifications,
            notification,
            "NotificationType"
          );
          ConnectionHandler.insertEdgeAfter(notifications, notificationEdge);
          if (notification.getLinkedRecord("meeting")) {
            const notifications = ConnectionHandler.getConnection(
              viewer,
              "Events_eventsNotifications"
            );
            const notificationEdge = ConnectionHandler.createEdge(
              store,
              notifications,
              notification,
              "NotificationType"
            );
            ConnectionHandler.insertEdgeAfter(notifications, notificationEdge);
          }
        }
      },
      // optional but recommended:
      onCompleted: () => {
        /* server closed the subscription */
      },
      onError: (error) => console.error(error),
    }
  );
};



// WEBPACK FOOTER //
// ./src/subscriptions/NotificationSubscription.js